import { handleResponse, handleError, apiUrl, apiOptions } from './apiUtils';

const baseUrl = apiUrl + '/search';

export function search(query: string): Promise<unknown> {
  return fetch(`${baseUrl}?query=${query}`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}

export function searchRequests(query: string): Promise<unknown> {
  return fetch(`${baseUrl}/requests?query=${query}`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}

export function searchRequestGroups(query: string): Promise<unknown> {
  return fetch(`${baseUrl}/requestGroups?query=${query}`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}

export function searchGames(query: string): Promise<unknown> {
  return fetch(`${baseUrl}/games?query=${query}`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}

export function searchUsers(query: string): Promise<unknown> {
  return fetch(`${baseUrl}/users?query=${query}`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}
